import moment from "moment";
import constants from "../../../core/constants";
import isEmpty from "lodash/fp/isEmpty";
import each from "lodash/fp/each";
class Controller {
  constructor($mdDialog, $injector, Events, ride) {
    this.$mdDialog = $mdDialog;
    this.loading = false;
    this.Bookings = $injector.get("Bookings");
    this.Events = Events;
    this.confirmEvent = Events.getUpdateEvent("confirmEventTransfer");
    this.errorEvent = Events.eventsType.onShowErrorNotification;
    this.successEvent = Events.eventsType.onShowSuccessNotification;
    this.rideID = ride;
    this.BookingsTransforms = $injector.get("BookingsTransforms");
    this.waitingForResponse = false;
  }

  $onInit() {
    this.getBookings();
    this.getRideSuggestions = (bookingId) => {
      if (this.loading) return;
      this.loading = true;
      this.bookingId = bookingId;
      this.selectedCustomer = bookingId;
      this.availableRides = [];
      this.selectedRide = {};
      this.Bookings.transferSuggestions(bookingId).$promise.then((res) => {
        this.availableRides = this.formatRides(res.rides);

        this.loading = false;
      });
    };
    this.transfer = (bookingId) => {
      this.waitingForResponse = true;
      this.selectedRide = JSON.parse(this.selectedRide);
      const params = {
        new_ride_id: this.selectedRide.new_offer_id,
        reason: this.reason,
        pickupStationId: this.selectedRide.pickupStationId,
        dropoffStationId: this.selectedRide.dropoffStationId,
      };
      this.Bookings.transfer(bookingId, params)
        .$promise.then(() => {
          this.selectedRide = {};
          this.selectedCustomer = null;
          this.getBookings();
          this.availableRides = [];
          this.Events.emit(this.successEvent, {
            message: "User Transferred successfully",
          });
          this.waitingForResponse = false;
        })
        .catch((err) => {
          this.Events.emit(this.errorEvent, {
            message: err.data.message,
          });
          if (err.data.alternativeRides) {
            this.selectedRide = {};
            if (err.data.alternativeRides.length > 0) {
              this.availableRides = this.formatRides(err.data.alternativeRides);
            } else {
              this.availableRides = [];
            }
          }
        });
    };

    this.Events.on(this.confirmEvent, this.confirm.bind(this));
  }
  getBookings() {
    this.Bookings.getAll({ ride: this.rideID, limit: 0 }).$promise.then(
      (response) => {
        this.bookings = this.BookingsTransforms.justify(
          response.hits,
          this.rideID
        );

        this.bookingsUsers = [];
        each((booking) => {
          if (booking.status === "booked") {
            this.bookingsUsers.push({
              name: booking.user.name,
              id: booking.user._id,
              booking: booking._id,
              seat_count: booking.seat_count,
              pickup_time: moment(booking.pick_up_time).format(
                constants.timeFormat
              ),
              dropoff_time: moment(booking.drop_off_time).format(
                constants.timeFormat
              ),
            });
          }
        })(this.bookings);
        this.bookings = this.bookingsUsers;
        if (!this.initalBookingsLength) {
          this.initalBookingsLength = this.bookings ? this.bookings.length : 0;
        }
      },
      (response) => this.Events.emit(this.errorEvent, response.data)
    );
  }
  formatRides(rides) {
    rides.forEach((ride) => {
      ride.time = moment(ride.pickup_time).format(constants.timeFormat);
      ride.dropoff_time = moment(ride.dropoff_time).format(
        constants.timeFormat
      );
      ride.total_walking = Math.round(
        ride.total_walking / constants.fromMilliToMin
      );
      ride.station_changed = ride.station_changed ? "Yes" : "No";
    });

    return rides;
  }

  getRideSuggestionsList(bookingId, successCB) {
    this.availableRides = [];
    this.selectedRide = {};
    this.loading = true;
    this.Bookings.transferSuggestions(bookingId)
      .$promise.then((res) => {
        this.loading = false;
        if (successCB) successCB(this.formatRides(res.rides));
      })
      .catch(() => {
        this.loading = false;
        if (this.lastOfBulkTransfer) this.showSummary();
      });
  }
  transferAll() {
    if (!this.bookings) return;
    this.bulkTransferInitiated = true;
    this.showSummaryMsg = false;
    this.lastOfBulkTransfer = false;
    this.bookings.forEach(({ booking }, index) => {
      if (index === this.bookings.length - 1) {
        this.lastOfBulkTransfer = true;
      }
      this.transferToAlternatives(booking);
    });
  }
  transferToAlternatives(bookingId) {
    this.getRideSuggestionsList(bookingId, (suggestedRides) => {
      if (!suggestedRides) return;
      const tryAlternativeIndex = 0;
      const currentRide = suggestedRides[tryAlternativeIndex];
      this.silentBookTransfer(
        currentRide,
        bookingId,
        this.retryTransferToAlternative.bind(
          this,
          suggestedRides,
          bookingId,
          tryAlternativeIndex
        )
      );
    });
  }
  retryTransferToAlternative(
    suggestedRides,
    bookingId,
    currentAlternativeIndex
  ) {
    currentAlternativeIndex += 1;
    const currentRide = suggestedRides[currentAlternativeIndex];
    if (!currentRide) {
      this.showSummary();
      return;
    }
    this.silentBookTransfer(
      currentRide,
      bookingId,
      this.retryTransferToAlternative.bind(
        this,
        suggestedRides,
        bookingId,
        currentAlternativeIndex
      )
    );
  }
  silentBookTransfer(ride, bookingId, failureCB) {
    this.loading = true;
    const params = {
      new_ride_id: ride.new_offer_id,
      reason: this.reason,
      pickupStationId: ride.pickupStationId,
      dropoffStationId: ride.dropoffStationId,
    };
    this.Bookings.transfer(bookingId, params)
      .$promise.then(() => {
        this.afterSuccessfulTransfer(bookingId);
        if (this.lastOfBulkTransfer) this.showSummary();
      })
      .catch((err) => {
        this.Events.emit(this.errorEvent, {
          message: err.data.message,
        });
        if (
          err.data.alternativeRides ? err.data.alternativeRides.length : false
        ) {
          this.updateAvailableAlternatives(err.data.alternativeRides);
        }
        this.loading = false;
        if (failureCB) failureCB();
      });
  }
  updateAvailableAlternatives(alternatives) {
    this.selectedRide = {};
    this.availableRides = this.formatRides(alternatives);
  }
  afterSuccessfulTransfer(bookingId) {
    this.selectedRide = {};
    this.selectedCustomer = null;
    this.removeSuccessfulBook(bookingId);
    this.loading = false;
  }
  removeSuccessfulBook(bookingId) {
    this.bookings = this.bookings.filter(
      ({ booking }) => booking !== bookingId
    );
  }
  showSummary() {
    this.bulkTransferInitiated = false;
    this.successfulTransfers = this.initalBookingsLength - this.bookings.length;
    this.failedTransfers = this.bookings.length;
    this.lastBulkTransferTime = moment(new Date()).format(
      constants.enDateTimeFormat
    );
    this.showSummaryMsg = true;
  }

  confirm() {
    if (
      !isEmpty(this.selectedRide) &&
      this.selectedCustomer &&
      !this.waitingForResponse
    ) {
      this.transfer(this.bookingId);
    }
  }
  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/ride/transferBookingsUpdated/transferBookingsUpdated.controller.js